<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ title }}</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new pt-4 pb-6"
      :settings="settings"
    >
      <div class="p-6">
        <!-- NAME
        <vs-input label="Name" name="name" v-model="name" class="mt-5 w-full" />


        <vs-select v-model="category" label="Category" class="mt-5 w-full">
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.text"
            v-for="item in category_choices"
          />
        </vs-select>

        <vs-select v-model="order_status" label="Order Status" class="mt-5 w-full">
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.text"
            v-for="item in order_status_choices"
          />
        </vs-select>


        <vs-input label="Price" name="price" v-model="price" class="mt-5 w-full" />


        <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" />-->
        <formUser
          v-if="form == 'usuario'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formUser>

        <formRegional
          v-if="form == 'regional'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formRegional>

        <formDivisao
          v-if="form == 'divisao'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formDivisao>

        <formProgramaAfiliados
          v-if="form == 'ProgramaAfiliados'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formProgramaAfiliados>

        <formProgramaAfiliadosMetas
          v-if="form == 'ProgramaAfiliadosMetas'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formProgramaAfiliadosMetas>

        <formSetor
          v-if="form == 'Setor'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formSetor>

        <formTipoAtendimento
          v-if="form == 'Atendimento'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTipoAtendimento>

        <formPerfil
          v-if="form == 'Perfil'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formPerfil>

        <formGrupo
          v-if="form == 'Grupo'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formGrupo>

        <formTipoPagamento
          v-if="form == 'TipoPagamento'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTipoPagamento>

        <formProduto
          v-if="form == 'Produto'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formProduto>

        <formTabela
          v-if="form == 'Tabela'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTabela>

        <formTabelaValor
          v-if="form == 'TabelaValores'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTabelaValor>

        <formTipoFoto
          v-if="form == 'TipoFoto'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTipoFoto>

        <formRestricao
          v-if="form == 'Restricoes'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formRestricao>

        <formProposta
          v-if="form == 'Proposta'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formProposta>

        <formChamado
          v-if="form == 'Chamado'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formChamado>

        <formTabelaEstadosCidades
          v-if="form == 'TabelaEstadosCidades'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formTabelaEstadosCidades>

        <formEmpresaBeneficios
          v-if="form == 'EmpresaBeneficios'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formEmpresaBeneficios>

        <formIntegracaoSGA
          v-if="form == 'IntegracaoSGA'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formIntegracaoSGA>

        <formContaBancaria
          v-if="form == 'ContaBancaria'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        ></formContaBancaria>

        <formCotaParticipacao
          v-if="form == 'CotaParticipacao'"
          :sideBar="true"
          :dados="dadosSend"
          :tipo="'CotaParticipacoes'"
          :tipoCadastro="'Modelo'"
          :entidade="'CotaParticipacoes'"
          :pk="'idCotaParticipacao'"
          :isSideBar="true"
          @cancel="cancel"
          @concluido="concluido"
        ></formCotaParticipacao>

        <formVistoriador
          v-if="form == 'vistoriador'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formFornecedor
          v-if="form == 'Fornecedor'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formTipoFornecedor
          v-if="form == 'TipoFornecedor'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formSituacaoEvento
          v-if="form === 'SituaçãoEvento'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <formMotivoEvento
          v-if="form === 'MotivoEvento'"
          @cancel="cancel"
          @concluido="concluido"
          :sideBar="true"
          :dados="dadosSend"
        />

        <slot></slot>
      </div>
    </VuePerfectScrollbar>

    <!--div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6">Add Data</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div-->
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import formUser from './../forms/FormAddUser';
import formRegional from './../forms/FormRegional';
import formSetor from './../forms/FormSetor';
import formPerfil from './../forms/FormPerfil';
import formGrupo from './../forms/FormGrupo';
import formTipoPagamento from './../forms/FormTipoPagamento';
import formProduto from './../forms/FormProduto';
import formTabela from './../forms/FormTabela';
import formTabelaValor from './../forms/FormTabelaValor';
import formTipoFoto from './../forms/FormTipoFoto';
import formRestricao from './../forms/FormRestricao';
import formProposta from './../forms/formProposta';
import formChamado from './../forms/formChamado';
import formTabelaEstadosCidades from './../forms/formTabelaEstadosCidades';
import formEmpresaBeneficios from './../forms/formBeneficios';
import formIntegracaoSGA from './../forms/formIntegracaoSGA';
import formContaBancaria from './../forms/FormContaBancaria';
import formTipoAtendimento from './../forms/FormTipoAtendimento';
import formCotaParticipacao from './../forms/FormCotaParticipacao';
import formDivisao from './../forms/FormDivisao';
import formVistoriador from '../forms/FormVistoriador.vue';
import formProgramaAfiliados from './../forms/FormProgramaAfiliados.vue';
import formProgramaAfiliadosMetas from './../forms/FormProgramaAfiliadosMetas.vue';
import formSituacaoEvento from '../menu/eventos/situacoes-evento/situacoes-evento-form.vue';
import formMotivoEvento from '../menu/eventos/motivos-evento/motivos-evento-form.vue';
import formFornecedor from '../forms/FormFornecedor.vue';
import formTipoFornecedor from '../forms/FormTipoFornecedor.vue';

export default {
  components: {
    VuePerfectScrollbar,
    formUser,
    formRegional,
    formDivisao,
    formSetor,
    formPerfil,
    formGrupo,
    formTipoPagamento,
    formProduto,
    formTabela,
    formTabelaValor,
    formTipoFoto,
    formRestricao,
    formProposta,
    formChamado,
    formTabelaEstadosCidades,
    formEmpresaBeneficios,
    formIntegracaoSGA,
    formContaBancaria,
    formTipoAtendimento,
    formCotaParticipacao,
    formVistoriador,
    formProgramaAfiliados,
    formProgramaAfiliadosMetas,
    formFornecedor,
    formTipoFornecedor,
    formSituacaoEvento,
    formMotivoEvento,
  },
  props: {
    dados: {
      type: Object,
    },
    title: {
      type: String,
    },
    form: {
      type: String,
    },
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dadosSend: {},
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    // eslint-disable-next-line
    dados(value) {
      this.initValues();
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar');
        }
      },
    },
  },
  methods: {
    cancel() {
      this.isSidebarActiveLocal = false;
      //this.$emit("closeSidebar");
    },
    concluido() {
      this.isSidebarActiveLocal = false;
      this.$emit('concluido');
    },
    initValues() {
      this.dadosSend = this.dados;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
